import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngxui-sidenav-template-preview',
  templateUrl: './sidenav-template-preview.component.html',
  styleUrls: ['./sidenav-template-preview.component.scss']
})
export class SidenavTemplatePreviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
